module.exports = __webpack_public_path__ + "static/media/11.75003ef6.png";